import { SelfieProcessHandler } from "./baseHandler";
import { applicationStore } from "src/store/ApplicationStore";
import { LivenessImageMovementPayloadValues } from "src/enums/LivenessImageMovementPayloadValues";

export class LivenessHandler extends SelfieProcessHandler {
    constructor(navigateFn) {
        super();
        this.navigate = navigateFn;
    }

    async handle(image) {
        if (applicationStore.livenessImages.length > 0) {
            applicationStore.resetLivenessImages();
        }

        applicationStore.setLivenessImages({
            image,
            movement_payload: LivenessImageMovementPayloadValues.MATCH
        });

        this.navigate("/lc-start", { replace: true });
    }
}